<template>
  <div></div>
</template>
<script>
export default {
  name: 'DatalayerUpdate',
  props: {
    extraParams: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isActivated: false,
    };
  },
  computed: {
    isVtoInQueryString() {
      const params = new URLSearchParams(window.location.search);
      let value = params.get('utm_medium');
      return !!(value && value === 'vto');
    },
  },
  created() {
    window.eventBus.on('activate-vto-component', () => {
      this.$nextTick(() => {
        this.isActivated = true;
      });
    });
    this.additionalDatalayer();

    setTimeout(() => {
      this.ebsActivation();
    }, 1000);
  },
  methods: {
    additionalDatalayer() {
      window.refapp = window.refapp || {};
      if (this.isActivated || this.isVtoInQueryString) {
        const params = this.extraParams;
        params.add.products[0].dimension49 = 'activated';
        window.refapp.mctbEcommerce = params;
        return params;
      } else {
        window.refapp.mctbEcommerce = this.extraParams;
      }
    },
    initializeUpdateEAN(EAN) {
      if (typeof window.RefApp?.DSF?.SetEANNumber === 'function') {
        window.RefApp.DSF.SetEANNumber(EAN);
      }
    },
    onClickedSizeSelector() {
      const sizeSelectorEl = document.getElementsByClassName('oap-product-variants');
      if (!sizeSelectorEl.length) return;

      const sizeSelectorItems = sizeSelectorEl[0].querySelectorAll('.oap-product-variants__link');
      if (!sizeSelectorItems.length) return;

      sizeSelectorItems.forEach((el) => {
        const productId = el.getAttribute('product-id');
        const onClick = () => this.initializeUpdateEAN(productId);

        if (productId) el.addEventListener('click', onClick);
      });
    },
    ebsActivation() {
      const pdpTemplateEl = document.getElementsByClassName('oap-pdp-template');
      const isPDP = pdpTemplateEl.length ? true : false;
      const productEAN = this.extraParams?.add?.products[0]?.id;

      if (!isPDP || !productEAN) return;
      this.initializeUpdateEAN(productEAN);
      this.onClickedSizeSelector();
    },
  },
};
</script>
